import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ColdMemoriesPage from './pages/editoriales/ColdMemoriesPage';
// import ColdMemoriesPageSimple from './pages/editoriales/ColdMemoriesPageSimple';
import MentalBreakdownPage from './pages/editoriales/MentalBreakdownPage';
import XtremaStudioPage from './pages/editoriales/XtremaStudioPage';
import RougePage from './pages/editoriales/RougePage';
import BodegonPage from './pages/editoriales/BodegonPage';
import BoudoirPage from './pages/editoriales/BoudoirPage';
import DemeoPage from './pages/editoriales/DemeoPage';
import DysmorphiaPage from './pages/editoriales/DysmorphiaPage';
import GentlemanPage from './pages/editoriales/GentlemanPage';
import GravityPage from './pages/editoriales/GravityPage';
import JaqueAlReyPage from './pages/editoriales/JaqueAlReyPage';
import LagrimaSantaPage from './pages/editoriales/LagrimaSantaPage';
import StreetEditionPage from './pages/editoriales/StreetEditionPage';
import SusurrosDeAlgodonPage from './pages/editoriales/SusurrosDeAlgodonPage';
import WhispersOfTheTwentiesPage from './pages/editoriales/WhispersOfTheTwentiesPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/proyectos/editoriales/cold-memories" element={<ColdMemoriesPage />} />
          {/* <Route path="/proyectos/editoriales/cold-memories-simple" element={<ColdMemoriesPageSimple />} /> */}
          <Route path="/proyectos/editoriales/mental-breakdown" element={<MentalBreakdownPage />} />
          <Route path="/proyectos/editoriales/xtrema-studio" element={<XtremaStudioPage />} />
          <Route path="/proyectos/editoriales/rouge" element={<RougePage />} />
          <Route path="/proyectos/editoriales/bodegon" element={<BodegonPage />} />
          <Route path="/proyectos/editoriales/boudoir" element={<BoudoirPage />} />
          <Route path="/proyectos/editoriales/demeo" element={<DemeoPage />} />
          <Route path="/proyectos/editoriales/dysmorphia" element={<DysmorphiaPage />} />
          <Route path="/proyectos/editoriales/gentleman" element={<GentlemanPage />} />
          <Route path="/proyectos/editoriales/gravity" element={<GravityPage />} />
          <Route path="/proyectos/editoriales/jaque-al-rey" element={<JaqueAlReyPage />} />
          <Route path="/proyectos/editoriales/lagrima-santa" element={<LagrimaSantaPage />} />
          <Route path="/proyectos/editoriales/street-edition" element={<StreetEditionPage />} />
          <Route path="/proyectos/editoriales/susurros-de-algodon" element={<SusurrosDeAlgodonPage />} />
          <Route path="/proyectos/editoriales/whispers-of-the-twenties" element={<WhispersOfTheTwentiesPage />} />
          <Route path="/test" element={
            <div style={{ padding: '50px', backgroundColor: 'red', color: 'white', fontSize: '30px' }}>
              <h1>PÁGINA DE PRUEBA</h1>
              <p>Esta es la ruta /test que funciona</p>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
